export default __webpack_public_path__ + "static/media/info_faucet_tooltip.1b344c5a.svg";